"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderAutomaticEmailType = void 0;
// Re-export from @daytrip/legacy-enums
var legacy_enums_1 = require("@daytrip/legacy-enums");
Object.defineProperty(exports, "OrderAutomaticEmailType", { enumerable: true, get: function () { return legacy_enums_1.OrderAutomaticEmailType; } });
//# sourceMappingURL=OrderAutomaticEmailType.js.map